/**
 * Update Domain Command
 * 
 * Command for updating existing DDD Domain strategic models.
 * Includes validation and business rule enforcement.
 */

import { ICommand, BaseCommand } from '@swoft/core';

export interface UpdateDomainPayload {
  name?: string;
  description?: string;
  vision?: string;
  ubiquitousLanguage?: Record<string, string>;
}

export class UpdateDomainCommand extends BaseCommand implements ICommand {
  constructor(
    public readonly domainId: string,
    public readonly payload: UpdateDomainPayload,
    authSessionId: string,
    initiatedByPersonId: string,
    correlationId?: string
  ) {
    super(authSessionId, initiatedByPersonId, correlationId);
  }
}